import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { videos } from 'src/constants/videos'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      ctaText="Learn More"
      video={videos.liga_mx.videoUrl}
      staticAnnotation={videos.liga_mx.staticAnnotation}
      title="Watch Liga MX live on ESPN Deportes"
      subtitle="Stream on your phone, TV and more"
      networkSet="soccerLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/liga-mx-es-on-espn-deportes/"
      disableLAPlanCards={true}
    />
  )
}
